import { PageMeta } from '../types/content';

export const pages: PageMeta[] = [
  {
    order: 1,
    path: '/',
    title: 'About',
    description: 'Introduction and entry point to the executive profile.'
  },
  {
    order: 2,
    path: '/experiences',
    title: 'Experiences',
    description: 'Chronological executive career summary at Ameren and early-stage ventures.'
  },
  {
    order: 3,
    path: '/skills',
    title: 'Skills',
    description: 'Functional, operational, and executive competencies.'
  },
  {
    order: 4,
    path: '/executive-hero',
    title: 'Executive Hero & Board Positioning',
    description: 'Executive statement of purpose and enterprise leadership scope.'
  },
  {
    order: 5,
    path: '/impact-metrics',
    title: 'Executive Impact & Capital Metrics',
    description: 'Quantifiable enterprise achievements in a high-impact metric showcase.'
  },
  {
    order: 6,
    path: '/value-proposition',
    title: 'Strategic Value Proposition & Board Competencies',
    description: 'Core executive pillars relevant for C-suite and board governance.'
  },
  {
    order: 7,
    path: '/career-track-record',
    title: 'Executive Career Track Record',
    description: 'Milestone history, awards, and industry speaking engagements.'
  },
  {
    order: 8,
    path: '/technical-mastery',
    title: 'Technical Mastery & Systems Portfolio',
    description: 'Enterprise technology deployments and digital platforms.'
  },
  {
    order: 9,
    path: '/board-education',
    title: 'Board Experience, Education & Civic Leadership',
    description: 'Non-profit governance, academic background, and community contribution.'
  },
  {
    order: 10,
    path: '/contact',
    title: 'Board Inquiry & Direct Contact Portal',
    description: 'Executive contact interface and governance inquiry portal.'
  }
];

export const totalPages = pages.length;

export function getPageByPath(path: string): PageMeta {
  return pages.find(page => page.path === path) ?? pages[0];
}

export function getPageByOrder(order: number): PageMeta | undefined {
  return pages.find(page => page.order === order);
}

export const directoryPages = pages.filter(page => page.order !== 1);
